'use strict';
const nodeKey = require('@mindmup/mapjs-core/src/util/node-key');

module.exports = function nodeWithId(stageDOM, id) {
	if (!stageDOM || !stageDOM.querySelector || !id) {
		throw new Error('invalid-args');
	}
	return stageDOM.querySelector('#' + nodeKey(id));
};

